import angular from 'angular';

import sectionsLibraryService from './SectionsLibraryService';
import DndGuard from './DnDGuard';
import contentGuard from './../Workspace/ContentGuard/ContentGuardService';

const HEADER_HEIGHT = 36;
const SCROLL_ZONE_HEIGHT = 35;

const creatorSectionsLibrary = {
    bindings: {
      group: '@',
      context: '<'
  },
  template: require('./sections-library.html'),
  controller: function ($scope, $rootScope, dragulaService, SectionsLibraryService, ContentGuardService) {
    /** @ngInject() */


    this.$onInit = () => {
      this.sections = SectionsLibraryService.getSections(this.group);
      this.dragularScope = this.context.getDragularScope();
      this.dndGuard = new DndGuard();

      if(!dragulaService.find(this.dragularScope, this.dndGuard.sectionsLibraryClass)) {
        dragulaService.options(this.dragularScope, this.dndGuard.sectionsLibraryClass, {
          revertOnSpill: true,
          direction: 'vertical',
          moves: (el, source, handle) => {

            let sectionType = this.dndGuard.getSectionType(el);
            if(this.isSectionDisabled(sectionType, true)) {
                return false;
            }

            return this.dndGuard.isMovable(el, handle);
          },
          accepts: (el, target) => {
            return this.dndGuard.isAcceptable(el, target);
          },
          copy: (el) => {
            return this.dndGuard.isSectionElement(el);
          }
        });

        this.dragularScope.$on('sections-library.drop',  (el, target, source) => {
          if (this.dndGuard.hasSectionElementClass(target)) {
            $(target).css('display', 'none');
          }
        });

        this.dragularScope.$on('sections-library.drag', function(el, target, source){
          document.documentElement.addEventListener('mousemove', scrollFn);

        });

        this.dragularScope.$on('sections-library.dragend', function (el, target, source) {
          document.documentElement.removeEventListener('mousemove', scrollFn);
          clearInterval(timer);
        });
      }

    };

    this.isSectionDisabled = (sectionType, showAlert) => {
        return ContentGuardService.checkIsLocked(sectionType, showAlert);
    };

    let height = window.innerHeight;
    let timer = null;

    let scrollFn = (e) => {
      if (timer) {
        clearInterval(timer);
      }

      let fn = () => {
        if (e.clientY > height - SCROLL_ZONE_HEIGHT) {
          document.documentElement.scrollTop += 10;
        } else if (e.clientY < HEADER_HEIGHT + SCROLL_ZONE_HEIGHT) {
          document.documentElement.scrollTop -= 10;
        }
      };

      fn();
      timer = setInterval(fn, 20);
    }
  }
};


export default angular.module('cms.creator.sections-library', [sectionsLibraryService, contentGuard])
  .component('creatorSectionsLibrary', creatorSectionsLibrary).name;



// WEBPACK FOOTER //
// ./src/cmsCore/Creator/SectionsLibrary/SectionsLibrary.js